<template>
<div id="containerbar" class="containerbar authenticate-bg">
        <!-- Start Container -->
        <div class="container">
            <div class="auth-box login-box">
                <!-- Start row -->
                <div class="row no-gutters align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-6 col-lg-5">
                        <!-- Start Auth Box -->
                        <div class="auth-box-right">
                            <div class="card">
                                <div class="card-body">
                                    <form  @submit.prevent="attemptLogin" action="#">
                                        <div class="form-head">
                                            <a href="/" class="logo"><img src="assets/images/logo.svg" class="img-fluid" alt="logo"></a>
                                        </div>                                        
                                       
                                        <div class="form-group">
                                            <input type="text" class="form-control" id="username" placeholder="Enter Username here" v-model="user.username" required="">
                                        </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control" id="password" placeholder="Enter Password here" v-model="user.password" required="">
                                        </div>
                                        
                                        <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>                        
                                      <button type="submit" class="btn btn-success btn-lg btn-block font-18  mb-3">Log in</button>
                                       <router-link :to="{name:'route-forgot'}" class="text-weight-semibold"><u>password dimenticata?</u></router-link>
                                    </form>
                                   
                                </div>
                            </div>
                        </div>
                        <!-- End Auth Box -->
                    </div>
                    <!-- End col -->
                </div>
                <!-- End row -->
            </div>
        </div>
        <!-- End Container -->
    </div>
  
        
</template>

<script>
import axios from 'axios';

    export default {
        name: 'ViewLogin',
        data() {
            return {
                user: {
                    username: '',
                    password: ''
                },
                errormessage: ''
            };
        },
        beforeMount() {

           // this.$store.commit('clearAuth');
        },
        methods: {
            attemptLogin() {
                var me = this;
                me.$store.commit('clearAuth');

                //this.$validator.validateAll().then(isValid => {
                //    me.error = "";
                //    if (isValid) {
                        this.$store
                            .dispatch('login', {
                                username: me.user.username,
                                password: me.user.password
                            }).then(response => {
                                console.log(response);
                                if (response.status == 200) {

                                    if (response.data.token != "") {
                                        var theToken = response.data.token;
                                        this.$store.commit('authUser', { user: response.data });
                                        this.$router.push({ name: 'route-index' });
                                    }
                                    else {
                                        me.errormessage = 'Attenzione, non riconosco le credenziali utilizzate';
                                    }

                                }
                            })
                            .catch(error => {
                                console.log(error);
                                me.errormessage = 'Attenzione, non riconosco le credenziali utilizzate';
                            });


                    //}
              //  });
            }
        }
    };
</script>
